// Third party JS imports
// Page loader
import './vendor/pace/pace.min.js';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import localeNb from '@angular/common/locales/nb';
import localeEs from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeDa from '@angular/common/locales/da';
import localeNl from '@angular/common/locales/nl';
import localeSv from '@angular/common/locales/sv';
import localePl from '@angular/common/locales/pl';
import localeEnGb from '@angular/common/locales/en-GB';
import localeIt from '@angular/common/locales/it';
import localeCs from '@angular/common/locales/cs';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BASE_BO_CONFIG } from './app/injectors';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

function loadLocaleData(localeId: string): void {

  const normalizedLocale = localeId.toLowerCase().split('-')[0];
  
  // Map of supported locales
  const localeMap: { [key: string]: any } = {
    'nb': localeNb,  // Norwegian Bokmål (nb-NO)
    'es': localeEs,  // Spanish (es-ES)
    'de': localeDe,  // German (de-DE)
    'fr': localeFr,  // French (fr-FR)
    'da': localeDa,  // Danish (da-DK)
    'nl': localeNl,  // Dutch (nl-NL)
    'sv': localeSv,  // Swedish (sv-SE)
    'pl': localePl,  // Polish (pl-PL)
    'en': localeEnGb, // English GB (en-GB)
    'it': localeIt,  // Italian (it-IT)
    'cs': localeCs   // Czech (cs-CZ)
  };

  const localeData = localeMap[normalizedLocale];
  
  if (localeData) {
    registerLocaleData(localeData, localeId);
  } else {
    console.warn(`Locale ${localeId} not supported, falling back to nl-NL`);
    registerLocaleData(localeNl, 'nl-NL');
  }
}

async function main() {

    try {
      const apiBaseUrl = environment.devtunnelEnabled && environment.devtunnelApiUrl ? environment.devtunnelApiUrl : environment.configApiURL;
      const url = apiBaseUrl + 'config/' + window.location.hostname;
      const data = await fetch(url);
      const config = await data.json(); 

      if (config.Config.EntraConfig)
        sessionStorage.setItem('entra', JSON.stringify(config.Config.EntraConfig)); 

      sessionStorage.setItem('culture', JSON.stringify(config.Config.Culture));
      sessionStorage.setItem('flags', JSON.stringify(config.Features));
      sessionStorage.setItem('endpoint', config.Config.apiURL);
      sessionStorage.setItem('ticketShopURL', config.Config.ticketShopURL);
      sessionStorage.setItem('phoneValidation', config.Config.PhoneValidation);

      //store the state if we don't already have one.
      if (sessionStorage.getItem('state') === null && config.State !== null) {
        //no state, store a new one. We only do this once, otherwise the shopper will get a new session upon every page refresh
        sessionStorage.setItem('state', config.State);
      }

      // Load locale data based on culture
      loadLocaleData(config.Config.Culture.Locale);

      await platformBrowserDynamic([
        { provide: BASE_BO_CONFIG, useValue: config.Config },
        { provide: LOCALE_ID, useValue: config.Config.Culture.Locale },
        { provide: MAT_DATE_LOCALE, useValue: config.Config.Culture.Locale }
      ]).bootstrapModule(AppModule);
    }
    catch (error) {
      console.error(error);
      window.location.href = "unavailable.html";
    }
}

main();
